import * as React from 'react';
import { SVGProps } from 'react';

const IconMagicSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M8.859 3.252a.211.211 0 0 1 .396 0l1.177 3.18c.214.579.67 1.035 1.248 1.25l3.182 1.177a.211.211 0 0 1 0 .396l-3.181 1.177a2.115 2.115 0 0 0-1.25 1.248l-1.176 3.182a.211.211 0 0 1-.396 0L7.68 11.681a2.114 2.114 0 0 0-1.248-1.25L3.252 9.256a.211.211 0 0 1 0-.396l3.18-1.178a2.114 2.114 0 0 0 1.25-1.248l1.177-3.181ZM3.575 1.138a.211.211 0 0 1 .396 0l.49 1.322c.106.29.334.517.624.624l1.323.49a.211.211 0 0 1 0 .397l-1.323.49c-.29.106-.518.334-.625.624l-.489 1.323a.211.211 0 0 1-.396 0l-.49-1.323a1.057 1.057 0 0 0-.625-.625l-1.322-.489a.211.211 0 0 1 0-.396l1.322-.49c.29-.108.517-.336.624-.625l.49-1.322Z" />
  </svg>
);
export default IconMagicSizeS;
